import { render, staticRenderFns } from "./actionPivoTable.vue?vue&type=template&id=06325ce0&"
import script from "./actionPivoTable.vue?vue&type=script&lang=js&"
export * from "./actionPivoTable.vue?vue&type=script&lang=js&"
import style0 from "./actionPivoTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports